<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      dark
      style="background-color: #9abe23"
    >
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <img src="../assets/img/d.png" alt="Logo" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="title"
              >Orden de Servicio Digital</v-list-item-title
            >
            <v-list-item-subtitle>OSD</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <v-list dense>
        <v-list-item
          v-for="([icon, text, link], i) in items"
          :key="i"
          link
          @click="$vuetify.goTo(link)"
        >
          <v-list-item-icon class="justify-center">
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="subtitile-1">{{
              text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      :color="color"
      :flat="flat"
      dark
      class="px-7"
      :class="{ expand: flat }"
    >
      <v-toolbar-title v-if="isXs">
        <v-img src="@/assets/img/d.png" max-width="50px" />
      </v-toolbar-title>
      <v-toolbar-title v-else>
        <v-img src="@/assets/img/didocu1.png" max-width="80px" />
      </v-toolbar-title>
      <v-spacer />
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="mr-4"
        v-if="isXs"
      />
      <div v-else>
        <v-btn text @click="$vuetify.goTo('#features')">
          <span class="mr-2">Características</span>
        </v-btn>
        <v-btn text @click="$vuetify.goTo('#formats')">
          <span class="mr-2">ORDENES</span>
        </v-btn>
        <v-btn text @click="$vuetify.goTo('#testimonios')">
          <span class="mr-2">Testimonios</span>
        </v-btn>
        <v-btn text @click="$vuetify.goTo('#faq')">
          <span class="mr-2">PREGUNTAS</span>
        </v-btn>
        <v-btn
          rounded
          color="white"
          :href="'https://wa.me/+5214434846542?text=Estoy%20interesado%20en%20el%20servicio.'"
          target="_blank"
          style="color: red"
        >
          <span class="mr-2"
            >Compra <v-icon class="ml-2">mdi-cart</v-icon></span
          >
        </v-btn>
      </div>
    </v-app-bar>
  </div>
</template>

<style scoped>
.v-toolbar {
  transition: 0.6s;
}

.expand {
  height: 80px !important;
  padding-top: 10px;
}
</style>

<script>
export default {
  data: () => ({
    drawer: null,
    isXs: false,
    items: [
      ["mdi-home-circle", "Inicio", "#hero"],
      ["mdi-puzzle", "Características", "#features"],
      ["mdi-gesture", "Testimonios", "#testimonios"],
      [
        "mdi-phone",
        "Compra",
        "https://wa.me/+5214434846542?text=Estoy%20interesado%20en%20el%20servicio.",
      ],
    ],
  }),
  props: {
    color: String,
    flat: Boolean,
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
  },

  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>
